import { useState, useCallback } from "react";
function c(u = 0) {
  let [t, l] = useState(u), g = useCallback((e) => l(e), [t]), s = useCallback((e) => l((a) => a | e), [t]), m = useCallback((e) => (t & e) === e, [t]), n = useCallback((e) => l((a) => a & ~e), [l]), F = useCallback((e) => l((a) => a ^ e), [l]);
  return { flags: t, setFlag: g, addFlag: s, hasFlag: m, removeFlag: n, toggleFlag: F };
}
export {
  c as useFlags
};
